import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Modal from "../shared/Modal";
import UploadInformation from "../upload/UploadInformation";
import EstateAssociation from "../upload/EstateAssociation";

const AssociationModal = ({ selectedFile, open, onClose }) => {
  const [step, setStep] = useState(1);
  const [data, setData] = useState();

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      name: selectedFile.name,
      documentType: selectedFile.documentType,
      effectiveDate: selectedFile.effectiveDate,
      offices: selectedFile.offices || [],
    },
  });

  useEffect(() => {
    return () => {
      setStep(1);
      setData(null);
    };
  }, [open]);

  return (
    <Modal open={open} handleClose={onClose}>
      {step === 1 && (
        <UploadInformation
          file={selectedFile}
          nextStep={() => setStep(2)}
          handleCancel={onclose}
          setData={setData}
          control={control}
          handleSubmit={handleSubmit}
          setValue={setValue}
        />
      )}
      {step === 2 && (
        <EstateAssociation
          uuid={selectedFile?.uuid}
          file={selectedFile}
          data={data}
          handleBack={() => setStep(1)}
          closeModal={onClose}
        />
      )}
    </Modal>
  );
};

export default AssociationModal;
